import * as Factory from 'factory.ts'
import { faker } from '@faker-js/faker'
import { Automation } from '../models/Automation'
import { answerFactory } from './AnswerFactory'

export const automationFactory = Factory.Sync.makeFactory<Automation>({
  id: Factory.each((i) => i.toString()),
  isActive: Factory.each(() => faker.datatype.boolean()),
  shouldReact: Factory.each(() => faker.datatype.boolean()),
  name: Factory.each(() => faker.word.words(2)),
  notFollowerAnswers: [],
  followerAnswers: [],
  delayBetweenMessages: 10,
  followerReplyDelay: 230,
  notFollowerReplyDelay: 560,
  followerTimeLimiter: 25660,
  notFollowerTimeLimiter: 84650,
})
